import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "text-content"
};
const _hoisted_2 = {
  class: "ellipsis ellipsis-3"
};
const _hoisted_3 = {
  class: "status-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_WrapWithStatusIcon = _resolveComponent("WrapWithStatusIcon");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    class: "item-highlight-background-color-cell"
  }, {
    default: _withCtx(() => [_createVNode(_component_WrapWithStatusIcon, {
      validationStatus: $props.highlight.ui_style.validationStatus,
      status: $props.highlight.ui_style.status,
      id: $props.highlight.id,
      class: _normalizeClass({
        'copying-hovered': _ctx.is_copying,
        'is-copied': $data.isClicked && _ctx.is_copying
      }),
      ref: $props.highlight.id
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass(['content-box', 'item-highlight', 'is-hovering']),
        onClick: _cache[0] || (_cache[0] = $event => !this.is_copying ? _ctx.$emit('onEdit', {
          item: $props.item,
          type: $props.highlight.type,
          title: $props.highlight.title
        }) : _ctx.$emit('onPaste', {
          item: $props.item,
          type: $props.highlight.type,
          title: $props.highlight.title
        }))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
        style: _normalizeStyle($props.highlight.ui_style.style)
      }, [$props.highlight.text !== null && typeof $props.highlight.text !== 'undefined' && $props.highlight.text.trim() != '' ? (_openBlock(), _createBlock(_component_WrapWithCopy, {
        key: 0,
        onCopied: $options.handleCopied
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_2, _toDisplayString($props.highlight.text.trim()), 1)]),
        _: 1
      }, 8, ["onCopied"])) : _createCommentVNode("", true)], 4), $props.highlight.ui_style.status != 'unknown' && $props.index == 0 ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 0,
        target: $props.highlight.id,
        "auto-width": "",
        placement: "top",
        "custom-class": `${$props.highlight.ui_style.status} ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString($props.highlight.ui_style.tooltipText), 1)])]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true), !$props.item.sku ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 1,
        target: $props.highlight.id,
        "auto-width": "",
        placement: "top",
        "custom-class": `not-editable ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createTextVNode(" Assign SKU to the item to start editing the content ")]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true)])])]),
      _: 1
    }, 8, ["validationStatus", "status", "id", "class"])]),
    _: 1
  });
}